import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { changePassword } from 'actions/users';
import DeviseLayout from './DeviseLayout';

class ResettPasswordPage extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    // actions
    changePassword: PropTypes.func.isRequired,
  }

  onSubmit = (e) => {
    e.preventDefault();
    const password = this.password.value;
    const passwordConfirmation = this.passwordConfirmation.value;
    this.props.changePassword(this.props.history.location.search, { password, passwordConfirmation });
  }

  render() {
    const { t } = this.props;
    return (
      <DeviseLayout
        allowAuthenticated
        title={t('auth.resetPasswordTitle')}
        subTitle={t('auth.resetPasswordSubtitle')}
        cta={t('auth.changePassword')}
        onSubmit={this.onSubmit}
      >
        <div>
          <input
            name='sp-reset-password'
            ref={_ref => this.password = _ref}
            autoCapitalize="none"
            type="password"
            placeholder={t('auth.newPassword')}
          />
          <input
            name='sp-reset-password-confirmation'
            ref={_ref => this.passwordConfirmation = _ref}
            autoCapitalize="none"
            type="password"
            placeholder={t('auth.confirmNewPassword')}
          />
        </div>
      </DeviseLayout>
    );
  }
}

export default connect(null, { changePassword })(withTranslation()(ResettPasswordPage))
